import { useEffect } from 'react';
import { message } from 'antd';

import {
  useSendVerifyCode,
} from '../../../hooks/api/claimBusiness';
import { getMessageInError } from '../../../hooks/fetch';

const useSendCode = () => {
  const {
    fetch, response, error, loading,
  } = useSendVerifyCode();

  useEffect(() => {
    if (response) {
      message.success('Verification code sent successfully');
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      message.error(getMessageInError(error));
    }
  }, [error]);

  return {
    fetch,
    response,
    error,
    loading,
  };
};

export default useSendCode;
